import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M433.536 426.667h412.928c3.755 0 6.87-2.134 6.87-4.736v-33.238c0-2.56-3.115-4.693-6.87-4.693h-412.97c-3.755 0-6.87 2.133-6.87 4.736v33.195c0 2.602 3.115 4.736 6.87 4.736zm0 170.666h412.928c3.755 0 6.87-2.133 6.87-4.736v-33.194c0-2.603-3.115-4.736-6.87-4.736h-412.97c-3.755 0-6.87 2.133-6.87 4.736v33.194c0 2.603 3.115 4.736 6.87 4.736zm412.97-384H177.494c-3.754 0-6.826 2.134-6.826 4.736v33.195c0 2.603 3.072 4.736 6.826 4.736h669.014c3.754 0 6.826-2.133 6.826-4.736v-33.237c0-2.56-3.072-4.694-6.826-4.694zm0 512H177.494c-3.754 0-6.826 2.134-6.826 4.736v33.195c0 2.603 3.072 4.736 6.826 4.736h669.014c3.754 0 6.826-2.133 6.826-4.736v-33.195c0-2.602-3.072-4.736-6.826-4.736zm-672.938-229.12l134.059 99.542c4.992 3.712 12.373.426 12.373-5.547V391.125c0-5.973-7.253-9.258-12.373-5.546l-134.059 99.498a6.827 6.827 0 000 11.179z"
});

function SvgOutdent(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "outdent_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), _ref, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdent);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'OutdentOutlined';

export default KuFoxIcons;
